import { VALID_HOST } from './constant';

export function isValidHost(hostStr: string): boolean {
  if (hostStr) {
    for (let i = 0; i < VALID_HOST.length; i++) {
      if (hostStr.endsWith(VALID_HOST[i])) {
        return true;
      }
    }
  }
  return false;
}
